export const getHighestHubPlan = (ownedProducts, hub) => {
  if (!ownedProducts) {
    ownedProducts = [];
  }

  let highestLevel = 'free';
  ['starter', 'pro', 'enterprise'].forEach(priceLevel => {
    if (ownedProducts.includes(hub === 'marketing' ? `marketing-${priceLevel}` : `${hub}-${priceLevel}-bundle`)) {
      highestLevel = priceLevel;
    }
  });
  return highestLevel;
};